import { FileText, Users, Shield, CheckCircle, Clock, AlertCircle, Zap, Target, Briefcase } from "lucide-react";

export const mockData = {
  problems: [
    {
      icon: Briefcase,
      title: "Feast or Famine Workloads",
      description: "Volume is sporadic. Hiring a full-time associate for a 2-month spike destroys your margins.",
      impact: "Margin Destruction"
    },
    {
      icon: AlertCircle,
      title: "The 6-Month Training Lag",
      description: "Even if you hire, it takes months before a junior associate understands your firm's specific positions.",
      impact: "Months of Delay"
    },
    {
      icon: Users,
      title: "The \"Context Tax\"",
      description: "Traditional LPOs are black boxes. You spend more time fixing their lack of context than it would take to do the work yourself.",
      impact: "Time Wasted Fixing"
    }
  ],

  howItWorks: [
    {
      title: "We Index Your Brain (One-Time Setup)",
      description: "We ingest 5–10 of your \"Gold Standard\" documents (SHAs, MSAs, etc.). Our engine maps your positions to create a living \"Scope of Work.\""
    },
    {
      title: "You Send the Work",
      description: "Email us or upload the counterparty draft. No complex onboarding."
    },
    {
      title: "We Execute (The \"Super-Associate\" Workflow)",
      description: "A LevelLex Associate reviews the document. They use LevelLex to check every clause against your playbook. *They check for hygiene.* *They apply your standard clauses.* *They flag only the strategic deviations.*"
    },
    {
      title: "You Review",
      description: "You receive a **Standard Word Doc** (Redlined) + a **Deviation Report**. You review the 5% that matters, not the 95% that is hygiene."
    }
  ],

  processSteps: [
    {
      title: "We Index Your Brain (One-Time Setup)",
      description: "We ingest 5–10 of your \"Gold Standard\" documents (SHAs, MSAs, etc.). Our engine maps your positions to create a living \"Scope of Work.\""
    },
    {
      title: "You Send the Work",
      description: "Email us or upload the counterparty draft. No complex onboarding."
    },
    {
      title: "We Execute (The \"Super-Associate\" Workflow)",
      description: "A LevelLex Associate reviews the document. They use LevelLex to check every clause against your playbook."
    },
    {
      title: "You Review",
      description: "You receive a **Standard Word Doc** (Redlined) + a **Deviation Report**. You review the 5% that matters, not the 95% that is hygiene."
    }
  ],

  comparison: {
    features: [
      {
        feature: "Ramp-Up Time",
        genericLPO: "Weeks of training",
        genericAI: "Hours of prompting",
        levellex: "Zero (Instant Context via Data)"
      },
      {
        feature: "Consistency",
        genericLPO: "Variable (Depends on the person)",
        genericAI: "Variable (Hallucinates)",
        levellex: "Deterministic (Guardrailed by Code)"
      },
      {
        feature: "Workflow Friction",
        genericLPO: "High (You must fix errors)",
        genericAI: "High (Copy/Paste fatigue)",
        levellex: "Zero (We deliver polished Docs)"
      },
      {
        feature: "Audit Trail",
        genericLPO: "None",
        genericAI: "None",
        levellex: "Full Logic Log (Citation included)"
      }
    ]
  },

  benefits: [
    {
      icon: Clock,
      metric: "< 24 Hour Turnaround",
      description: "Get standard agreements turned around while you sleep."
    },
    {
      icon: Shield,  
      metric: "100% Auditable",
      description: "Every edit our associates make is traceable to a source document you trust."
    },
    {
      icon: CheckCircle,
      metric: "Zero Fixed Cost",
      description: "Stop paying salaries for fluctuating workloads. Pay for the capacity you use."
    }
  ],

  documentAnalysis: [
    {
      clause: "Comment on Clause 4 (Indemnification):",
      status: "applied",
      action: "Replaced \"Uncapped Liability\" with \"Cap at 1x Fees\"",
      source: "Acme Corp Series A (2023)",
      note: "Counterparty requested uncapped, but per your playbook, I have reverted to your standard cap."
    }
  ]
};
